'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var TEAM_MEMBER_ADD = exports.TEAM_MEMBER_ADD = 'TEAM_MEMBER_ADD';
var TEAM_MEMBER_ADD_NEW = exports.TEAM_MEMBER_ADD_NEW = 'TEAM_MEMBER_ADD_NEW';
var TEAM_MEMBER_REMOVE = exports.TEAM_MEMBER_REMOVE = 'TEAM_MEMBER_REMOVE';
var TEAM_MEMBERS_SET = exports.TEAM_MEMBERS_SET = 'TEAM_MEMBERS_SET';

var TEAM_MEMBER_STATES = exports.TEAM_MEMBER_STATES = {
    NEW: 'NEW', // user has not been added to the team before
    ADDED: 'ADDED', // user is an existing member of the team
    REMOVED: 'REMOVED' };


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/team/teamManagementConstants.js
// module id = 236
// module chunks = 0